import { render, staticRenderFns } from "./BasicTextarea.vue?vue&type=template&id=03867f14&scoped=true&"
import script from "./BasicTextarea.vue?vue&type=script&lang=js&"
export * from "./BasicTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BasicTextarea.vue?vue&type=style&index=0&id=03867f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03867f14",
  null
  
)

export default component.exports